import { render, staticRenderFns } from "./task_item.vue?vue&type=template&id=3f201514&scoped=true"
import script from "./task_item.vue?vue&type=script&lang=js"
export * from "./task_item.vue?vue&type=script&lang=js"
import style0 from "./task_item.vue?vue&type=style&index=0&id=3f201514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f201514",
  null
  
)

export default component.exports